import { PolarAngleAxis, RadialBar, RadialBarChart } from "recharts";

function Metric({ label, value, suffix = "", hint, testId }) {
  return (
    <div className="rounded-md border border-white/10 bg-card p-4" data-testid={testId}>
      <div className="label-eyebrow mb-2">{label}</div>
      <div className="font-mono text-2xl tracking-tight">{value}<span className="text-sm text-muted-foreground ml-1">{suffix}</span></div>
      {hint && <div className="text-[11px] text-muted-foreground mt-1">{hint}</div>}
    </div>
  );
}

export default function QualityReport({ report }) {
  if (!report) return null;
  const score = report.global_score ?? 0;
  const data = [{ name: "score", value: score, fill: "hsl(260 70% 60%)" }];
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-testid="quality-report">
      <div className="rounded-md border border-white/10 bg-card p-5 flex flex-col items-center justify-center">
        <div className="label-eyebrow mb-2">Score global</div>
        <div className="relative">
          <RadialBarChart width={180} height={180} innerRadius="78%" outerRadius="100%" data={data} startAngle={90} endAngle={-270}>
            <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
            <RadialBar background={{ fill: "hsl(230 20% 12%)" }} dataKey="value" cornerRadius={12} />
          </RadialBarChart>
          <div className="absolute inset-0 grid place-items-center">
            <div className="text-center">
              <div className="font-mono text-4xl">{score.toFixed ? score.toFixed(0) : score}</div>
              <div className="text-xs text-muted-foreground">/ 100</div>
            </div>
          </div>
        </div>
        <div className="mt-3 text-xs text-center text-muted-foreground max-w-[18rem]">{report.comment}</div>
      </div>
      <div className="lg:col-span-2 grid grid-cols-2 sm:grid-cols-3 gap-3">
        <Metric label="Rapport S/N" value={report.snr_after} hint={`Avant : ${report.snr_before} (${report.snr_gain_pct > 0 ? "+" : ""}${report.snr_gain_pct} %)`} testId="metric-snr" />
        <Metric label="Qualité du ciel" value={report.sky_quality_after} suffix="/100" hint={`Avant : ${report.sky_quality_before}`} testId="metric-sky" />
        <Metric label="Bruit (σ)" value={report.noise_sigma_after} hint={`Avant : ${report.noise_sigma_before}`} testId="metric-noise" />
        <Metric label="Dynamique" value={report.dynamic_range} testId="metric-dynamic" />
        <Metric label="Fidélité couleurs" value={report.color_fidelity} suffix="/100" testId="metric-color" />
        <Metric label="Netteté" value={Math.round(report.sharpness_after)} hint={`Avant : ${Math.round(report.sharpness_before)} (${report.detail_gain_pct > 0 ? "+" : ""}${report.detail_gain_pct} %)`} testId="metric-sharp" />
      </div>
    </div>
  );
}
